/* eslint-disable arrow-parens */
import { Route } from '@angular/router';
import { NoAuthGuard } from 'app/core/auth/guards/noAuth.guard';
import { LayoutComponent } from 'app/layout/layout.component';
import { EmptyLayoutComponent } from './layout/layouts/empty/empty.component';
import { SurveyForceInitialDataResolver } from './survey-force-initial.resolvers';
import { SurveyForceAccessGuard } from './core/auth/guards/survey-force-access.guard';
import { APP_PATH } from './modules/common/enum-constant';
import { FullWidthLayoutComponent } from './layout/layouts/full-width/full-width.component';
import { SurveyForceApprovalInitialDataResolver } from './survey-force-approval-initial.resolvers';

// @formatter:off
/* eslint-disable max-len */
/* eslint-disable @typescript-eslint/explicit-function-return-type */
export const appRoutes: Route[] = [
    {
        path: '',
        pathMatch: 'full',
        redirectTo: APP_PATH.START,
    },
    {
        path: '',
        canActivate: [NoAuthGuard],
        canActivateChild: [NoAuthGuard],
        component: EmptyLayoutComponent,
        children: [
            {
                path: APP_PATH.START,
                resolve: { surveyForceData: SurveyForceInitialDataResolver },
                loadChildren: () =>
                    import(
                        'app/modules/pages/start-pages/start-pages.module'
                    ).then((m) => m.StartPagesModule),
            },
            {
                canActivate: [SurveyForceAccessGuard],
                path: APP_PATH.SURVEY_FORCE,
                resolve: { surveyForceData: SurveyForceInitialDataResolver },
                loadChildren: () =>
                    import(
                        '@app/modules/survey-force/survey-force.module'
                    ).then((m) => m.SurveyForceComponentModule),
            },
            {
                path: APP_PATH.ERROR,
                loadChildren: () =>
                    import(
                        'app/modules/pages/error-pages/error-pages.module'
                    ).then((m) => m.ErrorPagesModule),
            },
            {
                path: APP_PATH.RESULT,
                loadChildren: () =>
                    import(
                        'app/modules/pages/result-pages/result-pages.module'
                    ).then((m) => m.ResultPagesModule),
            },
            {
                canActivate: [SurveyForceAccessGuard],
                path: APP_PATH.INFO_FORMS,
                loadChildren: () =>
                    import(
                        '@app/modules/pages/info-forms-page/info-forms-page.module'
                    ).then((m) => m.InfoFormsPageModule),
            },
            {
                canActivate: [SurveyForceAccessGuard],
                path: APP_PATH.SURVEY_FORCE_QUIZ,
                resolve: { surveyForceData: SurveyForceInitialDataResolver },
                loadChildren: () =>
                    import(
                        '@app/modules/survey-force-quiz/survey-force-quiz.module'
                    ).then((m) => m.SurveyForceQuizModule),
            },
        ],
    },
    {
        path: '',
        canActivate: [NoAuthGuard],
        canActivateChild: [NoAuthGuard],
        component: FullWidthLayoutComponent,
        children: [
            {
                path: APP_PATH.SURVEY_FORCE_EMBEDDED,
                resolve: { surveyForceData: SurveyForceInitialDataResolver },
                loadChildren: () =>
                    import(
                        'app/modules/survey-force-embedded/survey-force-embedded.module'
                    ).then((m) => m.SurveyForceEmbeddedComponentModule),
            },
            {
                canActivate: [SurveyForceAccessGuard],
                path: APP_PATH.SURVEY_FORCE_POPUP,
                resolve: { surveyForceData: SurveyForceInitialDataResolver },
                loadChildren: () =>
                    import(
                        '@app/modules/survey-force-popup/survey-force-popup.module'
                    ).then((m) => m.SurveyForcePopUpComponentModule),
            },
            {
                canActivate: [SurveyForceAccessGuard],
                path: APP_PATH.RESULT_POPUP,
                loadChildren: () =>
                    import(
                        'app/modules/pages/result-pages/result-pages.module'
                    ).then((m) => m.ResultPagesModule),
            },
            {
                canActivate: [SurveyForceAccessGuard],
                path: APP_PATH.APPROVE,
                resolve: {
                    approvalInfo: SurveyForceApprovalInitialDataResolver,
                },
                loadChildren: () =>
                    import(
                        '@app/modules/pages/approve-page/approve-page.module'
                    ).then((m) => m.ApprovePageModule),
            },
            {
                canActivate: [SurveyForceAccessGuard],
                path: APP_PATH.WEB_COMPONENT,
                loadChildren: () =>
                    import(
                        '@app/modules/pages/web-component-page/web-component-page.module'
                    ).then((m) => m.WebComponentPagesModule),
            },
            {
                canActivate: [SurveyForceAccessGuard],
                path: APP_PATH.REMOTE_CONFIG,
                loadChildren: () =>
                    import(
                        '@app/modules/pages/remote-config-page/remote-config-page.module'
                    ).then((m) => m.RemoteConfigPagesModule),
            },
        ],
    },
    {
        path: '**',
        component: LayoutComponent,
    },
];
